export enum LoaderType {
  contained = 'contained',
  fullscreen = 'fullscreen',
}
